import * as React from 'react';

export const CheckmarkHollowIcon: React.FC<{}> = () => (
    <svg className="dr-ui-checkmark-icon" viewBox="0 -225.36 225.36 225.36" xmlns="http://www.w3.org/2000/svg">
        <g id="Layer 1" transform="scale(1 -1)">
            <path
                d={`M 3.435,91.955 C -7.903,152.157 31.752,210.226 91.954,221.564 C 152.157,232.902 210.226,193.247
            221.564,133.045 C 232.902,72.842 193.247,14.773 133.044,3.435 C 72.842,-7.903 14.773,31.752
            3.435,91.955 Z M 131.627,10.962 C 187.675,21.517 224.593,75.578 214.037,131.627
            C 203.482,187.675 149.421,224.593 93.372,214.038 C 37.324,203.482 0.406,149.421 10.961,93.372
            C 21.517,37.324 75.578,0.406 131.627,10.962 Z`}
                className="svg-elt-fill"
                strokeLinejoin="miter"
                stroke="none"
                markerStart="none"
                markerEnd="none"
            />
            <path
                d={`M 70.239,130.899 L 98.153,103.886 L 156.231,161.513 L 179.192,140.802 L 99.503,63.816
            L 50.88,109.288 L 70.239,130.899 Z`}
                className="svg-elt-fill"
                strokeLinejoin="miter"
                stroke="none"
                markerStart="none"
                markerEnd="none"
            />
        </g>
    </svg>
);
